export default "/static/webpack/media/checkbox.52218d95.svg";